import PropTypes from 'prop-types'
import { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import Card from '@/components/Card'
import KeyValue from '@/components/KeyValue'

import messages from './messages'

class SamlConfiguration extends Component<any, any> {
  static displayName = 'SamlConfiguration'

  static propTypes = {
    acs: PropTypes.string,
    apiHost: PropTypes.string,
    companyCode: PropTypes.string,
    entityId: PropTypes.string,
    poolId: PropTypes.string
  }

  static defaultProps = {
    acs: '',
    apiHost: '',
    companyCode: '',
    entityId: '',
    poolId: ''
  }

  render() {
    return (
      <Card>
        <Card.Header title={<FormattedMessage {...messages.cardTitle} />} />
        <p>
          <FormattedMessage
            {...messages.description}
            values={{
              docsLink: (
                <a href="https://help.workgrid.com/s/article/How-to-Configure-SAML-Single-Sign-On-SSO">
                  <FormattedMessage {...messages.docsLink} />
                </a>
              )
            }}
          />
        </p>
        <KeyValue>
          <KeyValue.Label>
            <FormattedMessage {...messages.acs} />
          </KeyValue.Label>
          <KeyValue.Value>{this.props.acs}</KeyValue.Value>
        </KeyValue>
        <KeyValue>
          <KeyValue.Label>
            <FormattedMessage {...messages.entityId} />
          </KeyValue.Label>
          <KeyValue.Value>{this.props.entityId}</KeyValue.Value>
        </KeyValue>
        <KeyValue>
          <KeyValue.Label>
            <FormattedMessage {...messages.poolId} />
          </KeyValue.Label>
          <KeyValue.Value>{this.props.poolId}</KeyValue.Value>
        </KeyValue>
        <KeyValue>
          <KeyValue.Label>
            <FormattedMessage {...messages.companyCode} />
          </KeyValue.Label>
          <KeyValue.Value>{this.props.companyCode}</KeyValue.Value>
        </KeyValue>
        <KeyValue>
          <KeyValue.Label>
            <FormattedMessage {...messages.adminLoginUrl} />
          </KeyValue.Label>
          <span className="field__description">
            <FormattedMessage {...messages.adminLoginUrlDescription} />
          </span>
          <KeyValue.Value>
            {this.props.apiHost}
            <FormattedMessage {...messages.adminLoginPath} />
          </KeyValue.Value>
        </KeyValue>
      </Card>
    )
  }
}

export default SamlConfiguration
